<template>
  <div class="media-home">
    <div class="media-home-hero">
      <div class="hero-glow"></div>
      <div class="hero-content">
        <div class="hero-icon">
          <i class="fa-solid fa-layer-group"></i>
        </div>
        <h1 class="hero-title">{{ $t('integrations.media.menu.heroTitle') }}</h1>
        <p class="hero-subtitle">{{ $t('integrations.media.menu.heroSubtitle') }}</p>
      </div>
    </div>

    <div class="media-home-grid">
      <router-link to="/integrations/page/protokol-media/media" class="media-app-card">
        <div class="card-accent card-accent--media"></div>
        <div class="card-icon-wrap card-icon-wrap--media">
          <i class="fa-solid fa-photo-film"></i>
        </div>
        <div class="card-body-content">
          <h3 class="card-title">{{ $t('integrations.media.menu.mediaTitle') }}</h3>
          <p class="card-desc">{{ $t('integrations.media.menu.mediaDesc') }}</p>
        </div>
        <div class="card-arrow">
          <i class="fa-solid fa-arrow-right"></i>
        </div>
      </router-link>

      <router-link to="/integrations/page/protokol-media/documents" class="media-app-card">
        <div class="card-accent card-accent--docs"></div>
        <div class="card-icon-wrap card-icon-wrap--docs">
          <i class="fa-solid fa-file-lines"></i>
        </div>
        <div class="card-body-content">
          <h3 class="card-title">{{ $t('integrations.media.menu.docsTitle') }}</h3>
          <p class="card-desc">{{ $t('integrations.media.menu.docsDesc') }}</p>
        </div>
        <div class="card-arrow">
          <i class="fa-solid fa-arrow-right"></i>
        </div>
      </router-link>

      <router-link v-if="isPaidPlan" to="/integrations/page/protokol-media/ocr-models" class="media-app-card">
        <div class="card-accent card-accent--ocr"></div>
        <div class="card-icon-wrap card-icon-wrap--ocr">
          <i class="fa-solid fa-crop-simple"></i>
        </div>
        <div class="card-body-content">
          <h3 class="card-title">{{ $t('integrations.media.menu.ocrTitle') }}</h3>
          <p class="card-desc">{{ $t('integrations.media.menu.ocrDesc') }}</p>
        </div>
        <div class="card-arrow">
          <i class="fa-solid fa-arrow-right"></i>
        </div>
      </router-link>

      <div v-else class="media-app-card media-app-card--locked" @click="showPaidGate">
        <div class="card-accent card-accent--ocr"></div>
        <div class="card-icon-wrap card-icon-wrap--ocr">
          <i class="fa-solid fa-crop-simple"></i>
        </div>
        <div class="card-body-content">
          <h3 class="card-title">{{ $t('integrations.media.menu.ocrTitle') }}</h3>
          <p class="card-desc">{{ $t('integrations.media.menu.ocrDesc') }}</p>
        </div>
        <div class="card-arrow">
          <i class="fa-solid fa-lock"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    isPaidPlan() {
      return this.$store.getters['ocrModels/isPaidPlan']
    },
  },
  mounted() {
    this.$store.dispatch('ocrModels/fetchPlan')
  },
  methods: {
    async showPaidGate() {
      const confirmed = await this.$mainDialog.msgBoxConfirm(
        this.$t('integrations.media.ocr.upgradeHint'),
        {
          title: this.$t('integrations.media.ocr.paidBadge'),
          okTitle: this.$t('integrations.media.ocr.upgradePlan'),
        }
      )
      if (confirmed) {
        this.$router.push({ name: 'marketplace.List', query: { open: 'protokol-media' } })
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_custom.scss";

.media-home {
  min-height: 100%;
  padding: 40px 32px;
}

/* ── Hero ─────────────────────────────────── */
.media-home-hero {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  background: var(--bg-card);
  border: 1px solid var(--border-default);
  padding: 56px 48px 48px;
  margin-bottom: 36px;
  text-align: center;
}

.hero-glow {
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
  height: 300px;
  background: radial-gradient(ellipse at center, rgba(102, 126, 234, 0.18) 0%, transparent 70%);
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: linear-gradient(135deg, var(--primary-start), #8b5cf6);
  font-size: 26px;
  color: #fff;
  margin-bottom: 20px;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.35);
}

.hero-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 10px;
  letter-spacing: -0.5px;
}

.hero-subtitle {
  font-size: 1rem;
  color: var(--text-muted);
  margin: 0;
  max-width: 440px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

/* ── App Cards Grid ───────────────────────── */
.media-home-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.media-app-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 24px;
  background: var(--bg-card);
  border: 1px solid var(--border-default);
  border-radius: 16px;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--border-hover);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
    text-decoration: none;

    .card-arrow {
      opacity: 1;
      transform: translateX(0);
    }

    .card-icon-wrap--media {
      box-shadow: 0 6px 18px rgba(102, 126, 234, 0.4);
    }

    .card-icon-wrap--docs {
      box-shadow: 0 6px 18px rgba(139, 92, 246, 0.4);
    }

    .card-icon-wrap--ocr {
      box-shadow: 0 6px 18px rgba(16, 185, 129, 0.4);
    }
  }
}

/* Decorative left accent bar */
.card-accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 16px 0 0 16px;
}

.card-accent--media {
  background: linear-gradient(180deg, var(--primary-start), #60a5fa);
}

.card-accent--docs {
  background: linear-gradient(180deg, #8b5cf6, #c084fc);
}

.card-accent--ocr {
  background: linear-gradient(180deg, #10b981, #34d399);
}

/* Icon wrapper */
.card-icon-wrap {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #fff;
  transition: box-shadow 0.2s ease;
}

.card-icon-wrap--media {
  background: linear-gradient(135deg, var(--primary-start), #60a5fa);
}

.card-icon-wrap--docs {
  background: linear-gradient(135deg, #8b5cf6, #c084fc);
}

.card-icon-wrap--ocr {
  background: linear-gradient(135deg, #10b981, #34d399);
}

/* Text */
.card-body-content {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 6px;
}

.card-desc {
  font-size: 0.875rem;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.5;
}

/* Arrow */
.card-arrow {
  flex-shrink: 0;
  color: var(--text-muted);
  font-size: 0.95rem;
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

/* ── Locked card (free plan) ──────────────── */
.media-app-card--locked {
  opacity: 0.5;

  &:hover {
    transform: none;
    box-shadow: none;
    border-color: var(--border-default);

    .card-arrow {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .card-icon-wrap {
    filter: grayscale(1);
  }

  .card-accent--ocr {
    background: linear-gradient(180deg, #6b7280, #9ca3af);
  }
}

/* ── Responsive ───────────────────────────── */
@media (max-width: 600px) {
  .media-home {
    padding: 24px 16px;
  }

  .media-home-hero {
    padding: 36px 24px 32px;
  }

  .hero-title {
    font-size: 1.5rem;
  }
}
</style>
